import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { offersAction } from 'store';
import { StartRequest, RequestsCountries } from './fragments';
import { RequestsPageLayout } from 'Layout/RequestsPageLayout';
import { WarningModal } from 'containers/Welcome/fragments/WarningModal';
import { useOutsideClick } from 'hooks/useOutsideClick';
import { ModalWrapper } from 'components/buttons/StartYourTrip/styles';

export const Requests = () => {
  const { offers } = useSelector((state) => state.offersReducer);
  const { user } = useSelector(({ auth }) => auth);
  const dispatch = useDispatch();
  const { ref, isOpen, setIsOpen } = useOutsideClick();

  useEffect(() => {
    dispatch(offersAction.getOffers());
  }, []);

  const handleClick = () => {
    if (
      user?.data?.birthdate === null ||
      user?.data?.country === null ||
      user?.data?.city === null ||
      user?.city?.gender === null
    ) {
      setIsOpen(true);
    }
  };

  return (
    <>
      {isOpen ? (
        <ModalWrapper ref={ref}>
          <WarningModal />
        </ModalWrapper>
      ) : null}
      <RequestsPageLayout>
        {offers?.length === 0 ? (
          <StartRequest handleClick={handleClick} />
        ) : (
          <RequestsCountries />
        )}
      </RequestsPageLayout>
    </>
  );
};
